import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditPublished extends Component {

    state = {
        published: this.props.published,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { published = false } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditPublished"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Published">
            <Form>
                <div>
                    <label className="radio">
                        <input
                            type="radio"
                            checked={!published}
                            onChange={e => this.setState({ published: false })} />
                            No
                    </label>
                    <label className="radio">
                        <input
                            type="radio"
                            checked={published}
                            onChange={e => this.setState({ published: true })} />
                            Yes
                    </label>
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditPublished



// WEBPACK FOOTER //
// ./src/components/LBUs/EditPublished.js